export default {
  data() {
    return {
      // Weatherbit用
      weatherbitDescription: {
        '200': 'customThunderstormWithLightRain',
        '201': 'customThunderstormWithRain',
        '202': 'customThunderstormWithHeavyRain',
        '230': 'customThunderstormWithLightDrizzle',
        '231': 'customThunderstormWithDrizzle',
        '232': 'customThunderstormWithHeavyDrizzle',
        '233': 'customThunderstormWithHail',
        '300': 'customLightDrizzle',
        '301': 'customDrizzle',
        '302': 'customHeavyDrizzle',
        '500': 'customLightRain',
        '501': 'customModerateRain',
        '502': 'customHeavyRain',
        '511': 'customFreezingRain',
        '520': 'customLightShowerRain',
        '521': 'customShowerRain',
        '522': 'customHeavyShowerRain',
        '600': 'customLightSnow',
        '601': 'customSnow',
        '602': 'customHeavySnow',
        '610': 'customMixSnowRain',
        '611': 'customSleet',
        '612': 'customHeavySleet',
        '621': 'customSnowShower',
        '622': 'customHeavySnowShower',
        '623': 'customFlurries',
        '700': 'customMist',
        '711': 'customSmoke',
        '721': 'customHaze',
        '731': 'customSandDust',
        '741': 'customFog',
        '751': 'customFreezingFog',
        '800': 'customClearSky',
        '801': 'customFewClouds',
        '802': 'customScatteredClouds',
        '803': 'customBrokenClouds',
        '804': 'customOvercastClouds',
        '900': 'customUnknownPrecipitation',
      },
      // Weathercom用
      weathercomDescription: {
        '0': 'customWeathercomTornado',
        '1': 'customWeathercomTropicalStorm',
        '2': 'customWeathercomHurricane',
        '3': 'customWeathercomStrongStorms',
        '4': 'customWeathercomThunderstorms',
        '5': 'customWeathercomRainSnow',
        '6': 'customWeathercomRainSleet',
        '7': 'customWeathercomWintryMix',
        '8': 'customWeathercomFreezingDrizzle',
        '9': 'customWeathercomDrizzle',
        '10': 'customWeathercomFreezingRain',
        '11': 'customWeathercomShowers',
        '12': 'customWeathercomRain',
        '13': 'customWeathercomFlurries',
        '14': 'customWeathercomSnowShowers',
        '15': 'customWeathercomBlowingDriftingSnow',
        '16': 'customWeathercomSnow',
        '17': 'customWeathercomHail',
        '18': 'customWeathercomSleet',
        '19': 'customWeathercomBlowingDustSandstorm',
        '20': 'customWeathercomFoggy',
        '21': 'customWeathercomHaze',
        '22': 'customWeathercomSmoke',
        '23': 'customWeathercomBreezy',
        '24': 'customWeathercomWindy',
        '25': 'customWeathercomFrigidIceCrystals',
        '26': 'customWeathercomCloudy',
        '27': 'customWeathercomMostlyCloudy',
        '28': 'customWeathercomMostlyCloudy',
        '29': 'customWeathercomPartlyCloudy',
        '30': 'customWeathercomPartlyCloudy',
        '31': 'customWeathercomClear',
        '32': 'customWeathercomSunny',
        '33': 'customWeathercomFairMostlyClear',
        '34': 'customWeathercomFairMostlySunny',
        '35': 'customWeathercomMixedRainandHail',
        '36': 'customWeathercomHot',
        '37': 'customWeathercomIsolatedThunderstorms',
        '38': 'customWeathercomScatteredThunderstorms',
        '39': 'customWeathercomScatteredShowers',
        '40': 'customWeathercomHeavyRain',
        '41': 'customWeathercomScatteredSnowShowers',
        '42': 'customWeathercomHeavySnow',
        '43': 'customWeathercomBlizzard',
        '44': 'customWeathercomNotAvailable',
        '45': 'customWeathercomScatteredShowers',
        '46': 'customWeathercomScatteredSnowShowers',
        '47': 'customWeathercomScatteredThunderstorms',
      },
    }
  },
  methods: {
    getWeatherDescription(weatherInfo) {
      const customWeatherDescriptionName = this.weathercomDescription[weatherInfo.weatherCode]
      if (typeof customWeatherDescriptionName === 'undefined') {
        return weatherInfo.weatherDescription
      }
      return this.$tt(customWeatherDescriptionName)
    },
  },
}
